import React, { useState } from 'react';
import { TextField, Button, Box } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';
import { EqForm } from '../../../hooks/apiHandler';

const ContactForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    number: '',
    cityName: '',
    businessName: '',
  });

  const [captchaToken, setCaptchaToken] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCaptcha = (token) => {
    setCaptchaToken(token);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      alert('Please complete the reCAPTCHA.');
      return;
    }

    try {
      var dataTosend = {
        ...formData, captchaToken
      }
      const response = await EqForm(dataTosend);
      console.log(dataTosend);
      console.log('Success:', response);
      if (onClose) onClose();
    } catch (error) {
      console.error('Error submitting contact form:', error);
      alert('There was an error submitting the form. Please try again.');
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        mx: 'auto',
        p: 4,
        borderRadius: 2
      }}
    >
      <TextField
        sx={{ borderRadius: '20px !important' }}
        name="name"
        label="Name"
        placeholder="Enter your name"
        value={formData.name}
        onChange={handleChange}
        required
      />
      <TextField
        sx={{ borderRadius: '20px !important' }}
        name="email"
        label="Email"
        type="email"
        placeholder="Enter your email"
        value={formData.email}
        onChange={handleChange}
        required
      />
      <TextField
        sx={{ borderRadius: '20px !important' }}
        name="number"
        label="Phone Number"
        type="tel"
        placeholder="Enter your phone number"
        value={formData.number}
        onChange={handleChange}
        required
      />
      <TextField
        sx={{ borderRadius: '20px !important' }}
        name="cityName"
        label="City Name"
        placeholder="Enter your City Name"
        value={formData.cityName}
        onChange={handleChange}
        required
      />
      <TextField
        sx={{ borderRadius: '20px !important' }}
        name="businessName"
        label="Business Name"
        placeholder="Enter your Business Name"
        value={formData.businessName}
        onChange={handleChange}
        required
      />

      <ReCAPTCHA
        sitekey="6LfAJIsrAAAAAMYx3GqDOPPYzZsGKasAj_xPkQwU" // site key
        onChange={handleCaptcha}
      />

      <Button sx={{ background: 'tomato' }} type="submit" variant="contained">
        Submit
      </Button>
    </Box>
  );
};

export default ContactForm;
